// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonInfinity_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.27231 9.35631L5.26076 9.36862L5.2372 9.3933C4.48986 10.1629 3.27818 10.1629 2.53084 9.3933C1.7835 8.62366 1.7835 7.37584 2.53084 6.60621C3.27818 5.83658 4.48986 5.83658 5.2372 6.60621L5.26122 6.63138L5.273 6.64393L6.58956 7.99977L6.57234 8.01751L7.99901 9.41787L7.99999 9.41686L9.32458 10.781C9.33944 10.7968 9.35445 10.8125 9.36961 10.8281C10.8864 12.3901 13.3456 12.3901 14.8624 10.8281C16.3792 9.26604 16.3792 6.73346 14.8624 5.17141C13.3456 3.60937 10.8864 3.60937 9.36961 5.17141C9.35293 5.1886 9.33643 5.2059 9.32011 5.22331L8.71966 5.84167L10.1412 7.24731L10.7258 6.64532L10.738 6.6323C10.7462 6.62356 10.7544 6.61486 10.7629 6.60621C11.5102 5.83658 12.7219 5.83658 13.4692 6.60621C14.2165 7.37584 14.2165 8.62366 13.4692 9.3933C12.7219 10.1629 11.5102 10.1629 10.7629 9.3933L10.7402 9.3696L10.7291 9.35779L9.41049 7.99983L9.42421 7.9857L8.00276 6.57996L8.00005 6.58274L6.67823 5.22149C6.66247 5.20469 6.64654 5.188 6.63044 5.17141C5.11363 3.60937 2.65441 3.60937 1.1376 5.17141C-0.379201 6.73346 -0.379201 9.26604 1.1376 10.8281C2.65441 12.3901 5.11363 12.3901 6.63044 10.8281C6.64622 10.8118 6.66185 10.7955 6.67731 10.779L7.28702 10.1511L5.86035 8.75074L5.27231 9.35631Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonInfinity is a generated icon component.
 */
let IconCommonInfinity = IconCommonInfinity_1 = class IconCommonInfinity extends IconBaseElement {
    render() {
        return html `${IconCommonInfinity_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonInfinity.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconCommonInfinity = IconCommonInfinity_1 = __decorate([
    customElement('zui-icon-common-infinity')
], IconCommonInfinity);
export { IconCommonInfinity };
